module.exports = __webpack_public_path__ + "static/media/Trades.53bb9611.svg";